import { Popover as MuiPopover, PopoverProps as MuiPopoverProps } from '@mui/material';

type Props = Pick<
  MuiPopoverProps,
  | 'action'
  | 'anchorEl'
  | 'open'
  | 'onClose'
  | 'anchorOrigin'
  | 'transformOrigin'
  | 'children'
  | 'keepMounted'
  | 'elevation'
  | 'className'
  | 'slots'
  | 'slotProps'
  | 'sx'
> & {
  testId?: string;
};

const Popover = ({
  action,
  anchorEl,
  open,
  onClose,
  anchorOrigin,
  transformOrigin,
  children,
  keepMounted,
  elevation,
  className,
  slots,
  slotProps,
  sx,
  testId,
}: Props) => {
  return (
    <MuiPopover
      action={action}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      keepMounted={keepMounted}
      elevation={elevation}
      className={className}
      slots={slots}
      slotProps={slotProps}
      sx={sx}
      test-id={testId}
    >
      {children}
    </MuiPopover>
  );
};

export type { Props as PopoverProps };
export default Popover;
